import type { FetchiosError } from "@caprikorn/dynamo-utils";
import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type {
  Consumption,
  GetConsumptionParams,
  UsePerimeterConsoQuery,
} from "./apiEcms.types";

const getConsumption = (
  { customerId, contractId, siteId, energy }: GetConsumptionParams,
  signal: AbortSignal,
) =>
  apiEcmsHttp.get<Consumption>(
    ["/consumption", customerId, contractId, siteId].filter(Boolean).join("/"),
    {
      signal,
      params: {
        energy,
      },
    },
  );

export const useGetConsumption = <TSelect = { data: Consumption }>({
  energy,
  enabled,
  customerId,
  contractId,
  siteId,
  select,
}: UsePerimeterConsoQuery<TSelect>) => {
  const { currentGroup } = useGroupReferences();

  return useQuery<
    {
      data: Consumption;
    },
    FetchiosError,
    TSelect
  >({
    queryKey: [
      QUERY_KEYS.CONSUMPTION,
      energy,
      customerId,
      contractId,
      siteId,
      currentGroup,
    ],
    queryFn: ({ signal }) =>
      getConsumption({ customerId, contractId, siteId, energy }, signal),
    enabled,
    select,
    staleTime: 1000 * 60 * 60 * 12,
    retry: false,
  });
};
